import { useState, useCallback } from 'react';
import { leaderService } from '../services/leaderService';

export const useLeader = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const getDashboard = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await leaderService.getDashboard();
      
      // CORRECTION : Si result n'a pas de propriété 'success', c'est directement les données
      if (result && typeof result === 'object') {
        if (result.success !== undefined) {
          // Format: { success: true, data: {...} }
          if (result.success) {
            setData(result.data);
          } else {
            setError(result.message || 'Erreur lors du chargement du dashboard');
          }
        } else {
          // Format: les données sont directement dans result
          setData(result);
        }
      } else {
        setError('Format de réponse invalide');
      }
      
      return { success: true, data: result };
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Erreur réseau';
      setError(errorMessage);
      return { success: false, message: errorMessage };
    } finally {
      setLoading(false);
    }
  }, []);

  // Appliquez la même correction aux autres fonctions
  const getFullTeam = useCallback(async (params) => {
    setLoading(true);
    setError(null);
    try {
      const result = await leaderService.getFullTeam(params);
      return result;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Erreur réseau';
      setError(errorMessage);
      return { success: false, message: errorMessage };
    } finally {
      setLoading(false);
    }
  }, []);

  const getTeamPerformance = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await leaderService.getTeamPerformance();
      return result;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Erreur réseau';
      setError(errorMessage);
      return { success: false, message: errorMessage };
    } finally {
      setLoading(false);
    }
  }, []);

  const downloadTeamReport = useCallback(async (params) => {
    setLoading(true);
    setError(null);
    try {
      const result = await leaderService.downloadTeamReport(params);
      return result;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Erreur réseau';
      setError(errorMessage);
      return { success: false, message: errorMessage };
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    data,
    getDashboard,
    getFullTeam,
    getTeamPerformance,
    downloadTeamReport
  };
};